import { LoadingKey } from '../app-active-loading/LoadingKey';
import { GoogleSyncAlertValue } from '../google-contacts-sync/googleContactsSyncConstants';
import { handleGoogleContactsCreateConnectionSuccess, handleGoogleContactsRequestError, handleLoginBeforeGoogleContactsSyncError } from '../google-contacts-sync/googleContactsSyncHandlers';
import { activateSync, createConnection, saveConnection } from '../google-contacts-sync/googleContactsSyncRequests';
import { setGoogleContactsSyncAlertCookieForUserGuideAlert } from '../google-contacts-sync/googleContactsSyncUtils';
import { loginNewUser } from '../http-login/loginNewUser';
import { handleLoginNewPortalSuccess } from '../http-survey/handleLoginNewPortalResponse';
import { EndpointKey } from '../http/EndpointKey';
import { getIsNewPortalCreated } from '../store/app/selectors';
import { googleContactsActivateSync } from '../store/auth/action-creators';
import { AuthActionTypes } from '../store/auth/action-types';
import { getCurrentStep } from '../store/flow/selectors';
import { Step } from '../views/Step';
export const EndpointsGoogleContactsSync = {
  [EndpointKey.LoginBeforeGoogleContactsSync]: {
    isStateOnlyTrigger: true,
    once: true,
    stateCheck: state => getIsNewPortalCreated(state) && getCurrentStep(state) === Step.GoogleContactsSync,
    method: loginNewUser,
    handleSuccess: (response, dispatch) => handleLoginNewPortalSuccess(dispatch),
    handleError: handleLoginBeforeGoogleContactsSyncError
  },
  [EndpointKey.GoogleContactsCreateConnection]: {
    reduxActionType: AuthActionTypes.GoogleContactsCreateConnection,
    loadingKey: LoadingKey.GoogleContactsSyncLoading,
    method: createConnection,
    handleSuccess: handleGoogleContactsCreateConnectionSuccess,
    handleError: (error, dispatch) => {
      dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsCreateConnection));
    }
  },
  [EndpointKey.GoogleContactsSaveConnection]: {
    reduxActionType: AuthActionTypes.GoogleContactsSaveConnection,
    method: saveConnection,
    handleSuccess: (response, dispatch) => {
      dispatch(googleContactsActivateSync());
    },
    handleError: (error, dispatch) => {
      dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsSaveConnection));
    }
  },
  [EndpointKey.GoogleContactsActivateSync]: {
    reduxActionType: AuthActionTypes.GoogleContactsActivateSync,
    method: activateSync,
    handleSuccess: () => {
      setGoogleContactsSyncAlertCookieForUserGuideAlert(GoogleSyncAlertValue.success);
    },
    handleError: (error, dispatch) => {
      dispatch(handleGoogleContactsRequestError(EndpointKey.GoogleContactsActivateSync));
    }
  }
};